export enum EnvelopeStatus {
  CREATED = 'created', // eslint-disable-line no-unused-vars
  SENT = 'sent', // eslint-disable-line no-unused-vars
  DELIVERED = 'delivered', // eslint-disable-line no-unused-vars
  SIGNED = 'signed', // eslint-disable-line no-unused-vars
  COMPLETED = 'completed', // eslint-disable-line no-unused-vars
  DECLINED = 'declined', // eslint-disable-line no-unused-vars
  VOIDED = 'voided', // eslint-disable-line no-unused-vars
  EXPIRED = 'expired', // eslint-disable-line no-unused-vars
  CORRECT = 'correct', // eslint-disable-line no-unused-vars
  TEMPLATE = 'template', // eslint-disable-line no-unused-vars
  DELETED = 'deleted', // eslint-disable-line no-unused-vars
  AUTHORITATIVE_COPY = 'authoritativecopy', // eslint-disable-line no-unused-vars
  TRANSFER_COMPLETED = 'transfercompleted', // eslint-disable-line no-unused-vars
  TIMEOUT = 'timeout', // eslint-disable-line no-unused-vars
  NO_STATUS = '_nostatus', // eslint-disable-line no-unused-vars
}

export const envelopeStatus = {
  // Draft/Creation Phase
  created: {
    label: 'EnvelopeStatusCreatedLabel',
    description: 'EnvelopeStatusCreatedDescription',
    color: 'gray',
    icon: 'ni-file-clock',
    phase: 'draft',
    badge: 'badge-gray',
  },

  // Active/In Process Statuses
  sent: {
    label: 'EnvelopeStatusSentLabel',
    description: 'EnvelopeStatusSentDescription',
    color: 'blue',
    icon: 'ni-clock',
    phase: 'active',
    badge: 'badge-info',
  },

  delivered: {
    label: 'EnvelopeStatusDeliveredLabel',
    description: 'EnvelopeStatusDeliveredDescription',
    color: 'blue',
    icon: 'ni-clock',
    phase: 'active',
    badge: 'badge-info',
  },

  signed: {
    label: 'EnvelopeStatusSignedLabel',
    description: 'EnvelopeStatusSignedDescription',
    color: 'orange',
    icon: 'ni-check-circle',
    phase: 'active',
    badge: 'badge-warning',
  },

  // Terminal/Final Statuses
  completed: {
    label: 'EnvelopeStatusCompletedLabel',
    description: 'EnvelopeStatusCompletedDescription',
    color: 'green',
    icon: 'ni-check-circle-fill',
    phase: 'final',
    badge: 'badge-success',
  },

  declined: {
    label: 'EnvelopeStatusDeclinedLabel',
    description: 'EnvelopeStatusDeclinedDescription',
    color: 'red',
    icon: 'ni-cross-circle',
    phase: 'final',
    badge: 'badge-danger',
  },

  voided: {
    label: 'EnvelopeStatusVoidedLabel',
    description: 'EnvelopeStatusVoidedDescription',
    color: 'warning',
    icon: 'ni-cross-circle',
    phase: 'final',
    badge: 'badge-warning',
  },

  expired: {
    label: 'EnvelopeStatusExpiredLabel',
    description: 'EnvelopeStatusExpiredDescription',
    color: 'red',
    icon: 'ni-clock',
    phase: 'final',
    badge: 'badge-danger',
  },

  // Special Statuses
  correct: {
    label: 'EnvelopeStatusCorrectLabel',
    description: 'EnvelopeStatusCorrectDescription',
    color: 'yellow',
    icon: 'ni-settings',
    phase: 'correction',
    badge: 'badge-warning',
  },

  template: {
    label: 'EnvelopeStatusTemplateLabel',
    description: 'EnvelopeStatusTemplateDescription',
    color: 'purple',
    icon: 'ni-file-text',
    phase: 'template',
    badge: 'badge-primary',
  },

  deleted: {
    label: 'EnvelopeStatusDeletedLabel',
    description: 'EnvelopeStatusDeletedDescription',
    color: 'gray',
    icon: 'ni-trash',
    phase: 'final',
    badge: 'badge-secondary',
  },

  authoritativecopy: {
    label: 'EnvelopeStatusAuthoritativeCopyLabel',
    description: 'EnvelopeStatusAuthoritativeCopyDescription',
    color: 'green',
    icon: 'ni-file-text',
    phase: 'final',
    badge: 'badge-success',
  },

  transfercompleted: {
    label: 'EnvelopeStatusTransferCompletedLabel',
    description: 'EnvelopeStatusTransferCompletedDescription',
    color: 'green',
    icon: 'ni-check-circle',
    phase: 'final',
    badge: 'badge-success',
  },

  timeout: {
    label: 'EnvelopeStatusTimeoutLabel',
    description: 'EnvelopeStatusTimeoutDescription',
    color: 'red',
    icon: 'ni-clock',
    phase: 'final',
    badge: 'badge-danger',
  },

  _nostatus: {
    label: 'EnvelopeStatusUnknownLabel',
    description: 'EnvelopeStatusUnknownDescription',
    color: 'gray',
    icon: 'ni-clock',
    phase: 'unknown',
    badge: 'badge-secondary',
  },
};

// Status color mapping for CSS classes
export const STATUS_CSS_CLASSES = {
  created: 'status-draft',
  sent: 'status-active',
  delivered: 'status-active',
  signed: 'status-progress',
  completed: 'status-success',
  declined: 'status-error',
  voided: 'status-error',
  expired: 'status-error',
  correct: 'status-warning',
  template: 'status-template',
  deleted: 'status-deleted',
  authoritativecopy: 'status-success',
  transfercompleted: 'status-success',
  timeout: 'status-error',
  _nostatus: 'status-secondary',
};

export const STATUS_COLORS = {
  created: 'badge-gray',
  sent: 'badge-info',
  delivered: 'badge-info',
  signed: 'badge-warning',
  completed: 'badge-success',
  declined: 'badge-danger',
  voided: 'badge-danger',
  expired: 'badge-danger',
  correct: 'badge-warning',
  template: 'badge-primary',
  deleted: 'badge-secondary',
  authoritativecopy: 'badge-success',
  transfercompleted: 'badge-success',
  timeout: 'badge-danger',
  _nostatus: 'badge-secondary',
};

export const STATUS_ICONS = {
  created: 'ni-file-text',
  sent: 'ni-send',
  delivered: 'ni-send',
  signed: 'ni-check-circle',
  completed: 'ni-check-circle',
  declined: 'ni-cross-circle',
  voided: 'ni-cross-circle',
  expired: 'ni-clock',
  correct: 'ni-wrench',
  template: 'ni-file-text',
  deleted: 'ni-trash',
  authoritativecopy: 'ni-file-text',
  transfercompleted: 'ni-check-circle',
  timeout: 'ni-clock',
  _nostatus: 'ni-clock',
};
